import React, { useState } from "react";
import { Event as EventIcon } from "@mui/icons-material";
import "../../assets/style/Timetable.css";

/**
 * A whole-day event rendered as a coloured bar above the timetable grid.
 *
 * These events hold no lessons, so there is nothing to sign up for — tapping
 * the bar just reveals the description when the admin provided one.
 */
const AllDayEventBar = ({ event }) => {
  const [expanded, setExpanded] = useState(false);
  const color = event.color || "#ff9800";
  const hasDescription = Boolean(event.description);

  return (
    <div
      className={`all-day-event ${hasDescription ? "clickable" : ""}`}
      style={{ backgroundColor: color }}
      onClick={hasDescription ? () => setExpanded((prev) => !prev) : undefined}
      title={event.description || event.name}
    >
      <div className="all-day-event__header">
        <EventIcon className="all-day-event__icon" fontSize="small" />
        <span className="all-day-event__name">{event.name}</span>
      </div>
      {hasDescription && expanded && (
        <div className="all-day-event__description">{event.description}</div>
      )}
    </div>
  );
};

export default AllDayEventBar;
